// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import searchSmIcon from "@/assets/icons/search-sm.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type SearchSmIconProps = Omit<IconProps, "name">;

export function SearchSmIcon(props: SearchSmIconProps): React.ReactNode {
  return <Icon name={searchSmIcon} {...props} />;
}
